// extracted by mini-css-extract-plugin
export default {"mineAreaInfo":"styles_mineAreaInfo__SNdzh","info":"styles_info__4RquA","initialInfo":"styles_initialInfo__84mNe","title":"styles_title__EL5j7","subInfo":"styles_subInfo__YPHfA"};